'use client'

import { useGSAPMedia } from '@/hooks'
import { useStorePageElements } from '@/store'
import { MEDIA } from '@config'
import { ScrollTrigger, gsap } from '@gsap'
import { memo, useRef } from 'react'

const HeaderTrigger = () => {
  const comp = useRef<any>(null)
  const { setShowHeaderBg } = useStorePageElements()

  useGSAPMedia({
    media: MEDIA,
    scope: comp,
    deps: [],
    callback: () => {
      gsap.registerPlugin(ScrollTrigger)

      ScrollTrigger.create({
        trigger: comp.current,
        end: 'bottom 90px',
        onEnter: () => {
          setShowHeaderBg(true)
        },
        onLeave: () => {
          setShowHeaderBg(false)
        },
        onEnterBack: () => {
          setShowHeaderBg(true)
        },
        onLeaveBack: () => {
          setShowHeaderBg(false)
        }
      })
    }
  })

  return <div ref={comp} className="pointer-events-none absolute inset-0"></div>
}

export default memo(HeaderTrigger)
